import styled from 'styled-components'
import { Card as CardComponent } from 'src/components/Ant'

const Card = styled(CardComponent)`
  margin-bottom: 16px;
`

export { Card }
